<template>
  <div class="bg-white border p-2 mt-3">
    <div class="table-responsive position-relative"
      :class="{ 'with-actions-gap': roles.length < 4, 'opacity-50': loading }">
      <table class="table">
        <caption class="sr-only" data-no-export>{{ i18n('Role list') }}</caption>
        <thead>
          <tr class="d-none d-lg-table-row">
            <th scope="col">{{ i18n('Id') }}</th>
            <th scope="col">{{ i18n('Name') }}</th>
            <th scope="col">{{ i18n('User Type') }}</th>
            <th scope="col">{{ i18n('Users') }}</th>
            <th scope="col">{{ i18n('Profiles') }}</th>
            <th scope="col">{{ i18n('Created At') }}</th>
            <th data-no-export scope="col" style="min-width: 48px">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <RoleListItem v-for="role in roles" :role="role" :key="role.id" @deleted="$emit('deleted', $event)"
            @updated="$emit('updated', $event)" @updating="$emit('updating', $event)" />
          <EmptyListItem v-if="!roles || roles.length == 0" :loading="loading" :colspan="8" />
          <LazyLoadListItem v-if="!loading && (lazyLoad || autoLazyLoad)"
            :autoLazyLoad="!pagination.singlePage && autoLazyLoad" :colspan="8" @next="$emit('next', $event)" />
        </tbody>
      </table>
      <div class="position-absolute h-100 w-100 top-0" @click.stop v-if="loading"></div>
    </div>
    <Pagination cssClass="mt-2" v-if="pagination && pagination.singlePage && pagination.limit < pagination.total"
      :pagination="pagination" :loading="loading" @goToPage="(...args) => $emit('goToPage', ...args)" />
  </div>
</template>

<script>
import RoleListItem from "@/components/role/RoleListItem.vue";
import EmptyListItem from "@/components/common/list/EmptyListItem.vue";
import LazyLoadListItem from "@/components/common/list/LazyLoadListItem.vue";
import Pagination from "@/components/common/list/Pagination.vue";
import Tooltip from "@/components/common/layout/Tooltip.vue";

export default {
  components: {
    RoleListItem,
    EmptyListItem,
    LazyLoadListItem,
    Pagination,
    Tooltip,
  },
  emits: [
    'updated',
    'deleted',
    'updated',
    'updating',
    'next',
    'goToPage',
  ],
  props: {
    loading: Boolean,
    lazyLoad: Boolean,
    autoLazyLoad: Boolean,
    pagination: Object,
    roles: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
  },
};
</script>